import React from 'react';
import { Navbar, Spinner } from 'react-bootstrap'; 

const Footer = ({isDownloading}) => {
    return (
        <Navbar fixed="bottom" bg="scb" className="justify-content-between pt-1 pb-1">
            <Navbar.Text className="text-white">
                Copyright &copy; 2019 Siam Commercial Bank Public Company Limited. All Rights Reserved.
            </Navbar.Text>
            {isDownloading &&
            <Navbar.Text className="text-white">
                <Spinner animation="border" size="sm" role="status"/>
            </Navbar.Text>
            }
        </Navbar>
    );
}

export default Footer;